import './svg.scss'
import SvgIcon from './svg'

export default SvgIcon